export default __webpack_public_path__ + "static/media/grid.87daa9cf.png";